module.exports = __webpack_public_path__ + "img/1970East-019_WEB-min.c5674b11.jpg";